import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getCurrentUser } from '../services/pocketbase';

/**
 * Composant de protection de route
 * @param {Object} children - Le composant à afficher si autorisé
 * @param {Array} allowedRoles - Liste des rôles autorisés (ex: ['admin', 'user'])
 */
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const isAuth = isAuthenticated();
    const user = getCurrentUser();

    if (!isAuth) {
        // Si pas connecté, rediriger vers l'accueil (la modal s'ouvrira si l'utilisateur clique sur login)
        // On pourrait aussi rediriger vers une page de login dédiée
        return <Navigate to="/" replace />;
    }

    // Si des rôles spécifiques sont requis
    if (allowedRoles.length > 0 && user) {
        // Vérifier si le rôle de l'utilisateur est dans la liste des rôles autorisés
        // Note: user.role vient de votre schéma PocketBase ("select" field)
        if (!allowedRoles.includes(user.role)) {
            // Redirection si rôle non autorisé (ex: un user normal essaie d'accéder à l'admin)
            return <Navigate to="/profil" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
